import { Link } from "react-router-dom";
import { MessageCircle, Mail, Phone, MapPin } from "lucide-react";

const WHATSAPP_NUMBER = "56929894282";
const WHATSAPP_MESSAGE = encodeURIComponent("Hola Odontofix, quiero cotizar mantención y agendar visita.");
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;
const EMAIL = "contacto@odontofix.cl";
const PHONE = "+56 9 2989 4282";
import { logoBlanco } from "@/lib/logos";

const navLinks = [
  { name: "Inicio", path: "/" },
  { name: "Servicios", path: "/servicios" },
  { name: "App Gratuita", path: "/app" },
  { name: "Nosotros", path: "/nosotros" },
  { name: "FAQ", path: "/faq" },
  { name: "Contacto", path: "/contacto" },
];

const serviceLinks = [
  { name: "Mantención Preventiva", path: "/servicios#preventiva" },
  { name: "Mantención Correctiva", path: "/servicios#correctiva" },
  { name: "Repuestos", path: "/servicios#repuestos" },
  { name: "Seguimiento", path: "/servicios#seguimiento" },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#384091] text-white" data-testid="main-footer">
      {/* Main Footer */}
      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="space-y-5">
            <img 
              src={logoBlanco} 
              alt="Odontofix Logo" 
              className="h-12 w-auto"
              loading="lazy"
            />
            <p className="text-white/80 text-sm leading-relaxed">
              Mantención preventiva y correctiva de equipamiento clínico y dental con trazabilidad completa y seguimiento profesional.
            </p>
            <div className="flex items-center gap-2 text-white/70 text-sm">
              <MapPin className="h-4 w-4 flex-shrink-0" />
              <span>Santiago y regiones de Chile</span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-5">Navegación</h4>
            <nav className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-white/80 hover:text-white text-sm transition-colors hover:translate-x-1 transform duration-200 inline-block w-fit"
                  data-testid={`footer-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-5">Contacto</h4>
            <div className="space-y-4">
              <a 
                href={`tel:${PHONE.replace(/\s/g, '')}`}
                className="flex items-center gap-3 text-white/80 hover:text-white text-sm transition-colors group"
                data-testid="footer-phone-link"
              >
                <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors">
                  <Phone className="h-4 w-4" />
                </div>
                <span>{PHONE}</span>
              </a>
              <a 
                href={`mailto:${EMAIL}`}
                className="flex items-center gap-3 text-white/80 hover:text-white text-sm transition-colors group"
                data-testid="footer-email-link"
              >
                <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors">
                  <Mail className="h-4 w-4" />
                </div>
                <span>{EMAIL}</span>
              </a>
              <a 
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/80 hover:text-white text-sm transition-colors group"
                data-testid="footer-whatsapp-link"
              >
                <div className="w-9 h-9 rounded-lg bg-[#25D366]/20 flex items-center justify-center group-hover:bg-[#25D366]/30 transition-colors">
                  <MessageCircle className="h-4 w-4 text-[#25D366]" />
                </div>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-5">¿Necesitas cotizar?</h4>
            <p className="text-white/80 text-sm mb-5 leading-relaxed">
              Escríbenos para cotizar mantención preventiva o correctiva de tus equipos clínicos.
            </p>
            <a 
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#25D366]/90 text-white px-5 py-3 rounded-lg font-medium text-sm transition-all hover:shadow-lg hover:-translate-y-0.5 transform duration-200"
              data-testid="footer-cta-whatsapp"
            >
              <MessageCircle className="h-4 w-4" />
              Cotizar por WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p className="text-white/60">
              © {currentYear} Odontofix. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6 text-white/60">
              <span>Mantención de equipos clínicos en Chile</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
